const ProViewToggle = ({ enabled, onChange }) => (
  <div className="flex items-center gap-2">
    <span className="text-xs sm:text-sm text-text-secondary">Pro View</span>
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      onClick={() => onChange(!enabled)}
      className={`relative w-8 h-5 sm:w-10 sm:h-6 rounded-full custom-transition ${
        enabled ? "bg-primary-300" : "bg-background-muted dark:bg-primary-600"
      }`}
    >
      <span
        className={`absolute top-0.5 sm:top-0.5 left-0.5 w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-background-surface shadow transition-transform ${
          enabled ? "translate-x-3 sm:translate-x-4" : "translate-x-0"
        }`}
      />
    </button>
  </div>
);

export default ProViewToggle;
